<div class="form-container single wider">
  <app-quest-view [quest]="quest"></app-quest-view>
</div>
